import { useState } from "react";
import axios from "axios";
import useUser from "../../useUser"; 
import toast, { Toaster } from "react-hot-toast"
import { Link } from "react-router-dom"


export default function VoteButton({eventID, gameDate, gameVotes, sport}){

    const { user } = useUser();

    const [upvotes, setUpvotes] = useState(gameVotes.upvotes);
    const [downvotes,setDownvotes] = useState(gameVotes.downvotes);
    const [hasUpvoted, setHasUpvoted] = useState(false)
    const [hasDownvoted, setHasDownvoted] = useState(false)


    const doUpvote = async (eventID, gameDate) =>{

        if(!user){
            toast.error("Please log-in to vote!");
            return;
        }

        if(hasUpvoted){
            toast("You've already updated this game!");
            toast.error("You have already upvoted this game!");
        }
        try{
            const token = user && await user.getIdToken();
            const headers = token ? { authToken: token }: {};
            const response = await axios.post(`/api/${sport}/${gameDate}/upvote/${eventID}`, null, { headers });
            setUpvotes(response.data.upvotes);
            setHasUpvoted(true)
            console.log("Upvote Success!");
        }catch(error){
            if(error.response?.status === 403){
                toast.error("You have already upvoted this game!");
                setHasUpvoted(true);
            }else if(error.response?.status === 401){
                toast.error("Please log in to Vote.");
            }else{
                toast.error("Unable to vote.")
            }
            console.error("Upvote failed: ", error);   

        }

    };

    const doDownvote = async (eventID, gameDate)=>{

        if(!user){
            toast.error("Please sign in!");
            return;   
        }

        if(hasDownvoted){
            console.log("You have already downvoted!");
            toast.error("You've already downvoted");
        }
        try{
            const token = user && await user.getIdToken();
            const headers = token ? { authToken: token } : {};
            const response = await axios.post(`/api/${sport}/${gameDate}/downvote/${eventID}`, null, { headers });
            setDownvotes(response.data.downvotes);
            setHasDownvoted(true);
            console.log("Successfully Downvoted.")
        }catch(error){
            if(error.response?.status === 403){
                toast.error("You've already downvoted");
            }else if(error.response?.status === 401){
                toast.error("Please log in to vote");
            }else{
                toast.error("Unable to downvote.")
            }
            console.log("There was an error: ", error);
        }
    }



    return(
        <>
        <div class="voting" id={eventID}>
            <div class="upvoting">
                <Toaster position="top-right"/>
                {user ? <span>{upvotes}</span> :<span>upvotes: {upvotes}</span>}
                {user ? <button onClick={()=>{doUpvote(eventID,gameDate)}} disabled={hasUpvoted} className={`${hasUpvoted} ? 'opacity-50 cursor-not-allowed' : ""}`}></button> 
                : <button className="loginButton-vote-page"><Link style={{textDecoration: 'none', color:'white'}}to="/loginpage">Sign In to Vote!</Link></button>}

            </div>
            <div class="downvoting">    
                {user && <button onClick={()=>{doDownvote(eventID, gameDate)}} disable={hasDownvoted} className={`${hasDownvoted} ? 'opacity-50 cursor-not-allowed' : ""`}></button>}
                {user ? <span>{downvotes}</span> : <span>downvotes: {downvotes}</span>}
            </div>
        </div>    
        </>
    )

}